import { convertDate, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import { Model } from 'modules/core/lib/mobx-rest'

import leaveTypes from 'modules/timeoff/store/collections/leaveTypes'
import type LeaveType from 'modules/timeoff/store/models/LeaveType'

const DEFAULT_COLOR = '#E2E2E5' // Grey/400

interface IBlockedPeriod {
  id: string
  policy_id: string
  policy_name: string
  start_on: string
  finish_on: string
  leave_type_ids: string[]
}

class BlockedPeriod extends Model<IBlockedPeriod> {
  constructor(attr: IBlockedPeriod) {
    super(attr)
  }

  static urlRoot() {
    return '/timeoff/blocked_periods'
  }

  get formattedStartOn(): string {
    return this.attributes.start_on ? convertDate(this.attributes.start_on, 'backend', 'ui') : ''
  }

  get formattedFinishOn(): string {
    return this.attributes.finish_on ? convertDate(this.attributes.finish_on, 'backend', 'ui') : ''
  }

  get periodColor(): string {
    return DEFAULT_COLOR
  }

  get leaveTypes(): LeaveType[] {
    const leaveTypeIds = this.attributes.leave_type_ids

    return leaveTypes.filter((t: LeaveType) => leaveTypeIds.includes(t.attributes.id))
  }

  get startEndSameYear(): boolean {
    return (
      stringToDate(this.attributes.start_on, 'backend').year() ===
      stringToDate(this.attributes.finish_on, 'backend').year()
    )
  }

  get rangeLabel(): string {
    const blockedPeriodStartFormat = this.startEndSameYear ? 'ui_dm_long' : 'ui_dmy_long'
    const blockedPeriodEndFormat = 'ui_dmy_long'

    return i18n.t('time_off.cycle', {
      begin: convertDate(this.attributes.start_on, 'backend', blockedPeriodStartFormat),
      end: convertDate(this.attributes.finish_on, 'backend', blockedPeriodEndFormat),
    })
  }
}

export default BlockedPeriod
